import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class ApiTokenCampaigns extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'ApiTokenCampaigns'
  static instanceDefaults() {
    return {
      user_id: null,
      music_id: null,
      campaign_type: 'PUBLIC',
      total_budget: 0,
      tokens_spent: 0,
      tokens_reserved: 0,
      status: 'PENDING',
      campaign_name: null,
      start_date: null,
      end_date: null,
      feedback_count: 0,
      target_feedback_count: null,
      metadata: {},
      allocations: []
    }
  }
}

const servicePath = 'api/token-campaigns';
const servicePlugin = makeServicePlugin({
  Model: ApiTokenCampaigns,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
